import { render } from "./Switcher.vue?vue&type=template&id=e9ed3108"
import script from "./Switcher.vue?vue&type=script&lang=js"
export * from "./Switcher.vue?vue&type=script&lang=js"

import "./Switcher.vue?vue&type=style&index=0&id=e9ed3108&lang=css"
script.render = render

export default script